import HeaderComponents from "segments/desktop/header";
import FooterComponents from "segments/desktop/footer";
import SegmentFamilies from "constants/segment-families";

export const isHeaderComponent = (segmentComponentName) => {
  return HeaderComponents[segmentComponentName];
};

export const isFooterComponent = (segmentComponentName) => {
  return FooterComponents[segmentComponentName];
};

export const isShapeComponent = (segmentFamily) => {
  return segmentFamily === SegmentFamilies.SHAPE;
};
